exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".C1qPgTlqf9Y7t0ml3EHcF{display:none}._1fUNAcJOHwVFh9BqSDLXu2{width:100%;height:calc(100% - 80px)}.G2EwK-c9YGqvxnB1GHcDM{height:calc(100% - 70px)}.P6cxIKyPIAjWQFeaZzdcd{display:block;top:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.P6cxIKyPIAjWQFeaZzdcd iframe{max-height:100%}.wdOcR00mWtKSYE12x1mhd{display:none}", ""]);
// Exports
exports.locals = {
	"divContainer": "C1qPgTlqf9Y7t0ml3EHcF",
	"extensionContainer": "_1fUNAcJOHwVFh9BqSDLXu2",
	"extensionContainerCalendar": "G2EwK-c9YGqvxnB1GHcDM",
	"extensionHost": "P6cxIKyPIAjWQFeaZzdcd",
	"hide": "wdOcR00mWtKSYE12x1mhd"
};